import * as React from "react";
import type { SVGProps } from "react";
const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      d="M5 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 20v-4h2v1h10V5H5v1H3V2q0-.824.587-1.412A1.93 1.93 0 0 1 5 0h10q.824 0 1.413.588Q17 1.175 17 2v18q0 .824-.587 1.413A1.93 1.93 0 0 1 15 22zm0-3v1h10v-1zm-3.6-3L0 14.6 5.6 9H2V7h7v7H7v-3.6zM5 3h10V2H5z"
    />
  </svg>
);
export default SvgText;
